import { AlertType } from "../../enums/AlertType";
import { Alert } from "../../interfaces/Alert";
export const ALERT_MARKETPLACE_ITEM_EDIT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translated: false,
  },
  message: {
    message: 'custom.marketplace_item_add_success',
    translated: true,
  },
};
